import React, { useContext, useState } from 'react';
import { Container, Row, Col, Button, Spinner, Accordion } from 'react-bootstrap';
import { AppContext } from '../App';


export const Notification = () => {
	const { accessToken, user, setAuthForm, link, notifications, getNotifiLoad, setNotification, setGetNotifiLoad, postCall, getCall } = useContext(AppContext);


	const [resolveLoad, setResolveLoad] = useState(false);
	const [eqId, setEqId] = useState();
	const resolved = (enq) => {
		setResolveLoad(true);
		postCall('api/rn/resolve/notification/', {
			notification_id: enq.substring(1),
		}).then((response) => {
			setResolveLoad(false);
			setNotification(response.data);
		}).catch((err) => {
			setResolveLoad(false);
		});
	}
	const pending = (enq) => {
		setResolveLoad(true);
		postCall('api/rn/pending/notification/', {
			notification_id: enq.substring(1),
		}).then((response) => {
			setResolveLoad(false);
			setNotification(response.data);
		}).catch((err) => {
			setResolveLoad(false);
		});
	}
	const [resolvedNotifi, setResolvedNotif] = useState();
	const [pendingNotifi, setPendingNotifi] = useState();
	const [tabState, setTabState] = useState('home');
	const getResolved = (key) => {
		setTabState(key);
		// Update button states
		document.querySelectorAll('.notifications-nav-item').forEach((btn, idx) => {
			btn.classList.remove('active');
		});
		const buttons = document.querySelectorAll('.notifications-nav-item');
		const indicator = document.querySelector('.notifications-nav-indicator');
		if (key === 'home') {
			buttons[0].classList.add('active');
			indicator.style.left = '6px';
		} else if (key === 'pending') {
			buttons[1].classList.add('active');
			indicator.style.left = 'calc(33.33% + 2px)';
			getCall(setGetNotifiLoad, 'api/rn/get/pending/notification/', setPendingNotifi);
		} else if (key === 'history') {
			buttons[2].classList.add('active');
			indicator.style.left = 'calc(66.66% - 2px)';
			getCall(setGetNotifiLoad, 'api/rn/get/resolved/notification/', setResolvedNotif);
		}
		// Update content visibility
		document.querySelectorAll('.notifications-tab-content').forEach((content, idx) => {
			content.style.display = 'none';
		});
		const contents = document.querySelectorAll('.notifications-tab-content');
		if (key === 'home') contents[0].style.display = 'block';
		else if (key === 'pending') contents[1].style.display = 'block';
		else if (key === 'history') contents[2].style.display = 'block';
	}
	const resolvedPeding = (enq) => {
		setResolveLoad(true);
		postCall('api/rn/resolve/pending/notification/', {
			notification_id: enq.substring(1),
		}).then((response) => {
			setResolveLoad(false);
			setPendingNotifi(response.data);
		}).catch((err) => {
			setResolveLoad(false);
		});
	}
	return (
		<div className='container-fluid'>
			{/* Modern Segmented Control Navigation */}
			<div className="notifications-nav-container">
				<div className="notifications-nav-wrapper">
					<button
						className="notifications-nav-item active"
						onClick={() => getResolved('home')}
					>
						<i className="bi bi-bell"></i>
						<span>Notifications</span>
					</button>
					<button
						className="notifications-nav-item"
						onClick={() => getResolved('pending')}
					>
						<i className="bi bi-hourglass-split"></i>
						<span>Pending</span>
					</button>
					<button
						className="notifications-nav-item"
						onClick={() => getResolved('history')}
					>
						<i className="bi bi-check-circle"></i>
						<span>Resolved</span>
					</button>
					<div className="notifications-nav-indicator"></div>
				</div>
			</div>
			<div className="d-flex align-items-center justify-content-between" >
				<span>{getNotifiLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Notifications.'}</span>
			</div>


			{/* Content Area */}
			<div className="notifications-content-area">
				<div className="notifications-tab-content">
					{
						notifications !== undefined ? (
							Object.keys(notifications).length > 0 ? (
								Object.keys(notifications).map((enq, enq_i) => (
									notifications[enq].status === false ? (
										<div className="enquiry-item grid8by2 align-items-center justify-content-between" key={`enq_${enq_i}`} >

											<Accordion className='p-2' >
												<Accordion.Item eventKey="0">
													<Accordion.Header><span className="tp1 f18" >{notifications[enq].service_name}, Expiry - {notifications[enq].expiry_date}</span></Accordion.Header>
													<Accordion.Body>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-calendar-event'></i><span>Created date</span>
															</div>
															<div className='enquiry-detail-value'>{notifications[enq].bill_created_date}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-calendar-event'></i><span>Expiry date</span>
															</div>
															<div className='enquiry-detail-value'>{notifications[enq].expiry_date}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-person'></i><span>Customer Name</span>
															</div>
															<div className='enquiry-detail-value'>{notifications[enq].customer_name}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-phone'></i><span>Contact number</span>
															</div>
															<div className='enquiry-detail-value'>{notifications[enq].customer_phone}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-house'></i><span>Address</span>
															</div>
															<div className='enquiry-detail-value'>{notifications[enq].customer_address}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-info-circle'></i><span>More details</span>
															</div>
															<div className='enquiry-detail-value'>{notifications[enq].details}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-currency-rupee'></i><span>Service charge</span>
															</div>
															<div className='enquiry-detail-value'>{notifications[enq].service_charge}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-info-circle'></i><span>Remarks</span>
															</div>
															<div className='enquiry-detail-value'>{notifications[enq].required_documents}</div>
														</div>
													</Accordion.Body>
												</Accordion.Item>
											</Accordion>
											<div className="enquiry-actions">
												{
													user !== undefined ? (
														user.type === 'admin' ? (
															eqId !== undefined && eqId === enq && resolveLoad ? (
																<Button className="enquiry-action-btn" disabled><Spinner animation="border" size="sm" /><span>Processing...</span></Button>
															) : (
																<>
																	<Button onClick={() => {
																		pending(enq);
																		setEqId(enq);
																	}} className="enquiry-action-btn pending"><i className="bi bi-clock-history"></i>Mark as Pending</Button>
																	<Button onClick={() => {
																		resolved(enq);
																		setEqId(enq);
																	}} className="enquiry-action-btn resolve"><i className="bi bi-check-circle"></i>Mark as resolved</Button>
																</>
															)
														) : (
															user.permission !== undefined ? (
																user.permission.notification !== undefined && user.permission.notification.E ? (
																	eqId !== undefined && eqId === enq && resolveLoad ? (
																		<Button className="enquiry-action-btn" disabled><Spinner animation="border" size="sm" /><span>Processing...</span></Button>
																	) : (
																		<>
																			<Button onClick={() => {
																				pending(enq);
																				setEqId(enq);
																			}} className="enquiry-action-btn pending">Mark as Pending</Button>
																			<Button onClick={() => {
																				resolved(enq);
																				setEqId(enq);
																			}} className="enquiry-action-btn resolve">Mark as resolved</Button>
																		</>
																	)
																) : ''
															) : ''
														)
													) : ''
												}
											</div>
										</div>
									) : ''
								))
							) : ''
						) : 'Not found'
					}
				</div>
				<div className="notifications-tab-content" style={{ display: 'none' }}>
					{
						pendingNotifi !== undefined ? (
							Object.keys(pendingNotifi).length > 0 ? (
								Object.keys(pendingNotifi).map((enq, enq_i) => (
									<div className="enquiry-item grid8by2 align-items-center justify-content-between" key={`enq_${enq_i}`} >

										<Accordion className="p-2">
											<Accordion.Item eventKey="0">
												<Accordion.Header><span className="tp1 f18" >{pendingNotifi[enq].service_name}, Expiry - {pendingNotifi[enq].expiry_date}</span></Accordion.Header>
												<Accordion.Body>
													<div className='enquiry-detail-row' >
														<div className='enquiry-detail-label'>
															<i className='bi bi-calendar-event'></i><span>Created date</span>
														</div>
														<div className='enquiry-detail-value'>{notifications[enq].bill_created_date}</div>
													</div>
													<div className='enquiry-detail-row' >
														<div className='enquiry-detail-label'>
															<i className='bi bi-calendar-event'></i><span>Expiry date</span>
														</div>
														<div className='enquiry-detail-value'>{notifications[enq].expiry_date}</div>
													</div>
													<div className='enquiry-detail-row' >
														<div className='enquiry-detail-label'>
															<i className='bi bi-person'></i><span>Customer Name</span>
														</div>
														<div className='enquiry-detail-value'>{notifications[enq].customer_name}</div>
													</div>
													<div className='enquiry-detail-row' >
														<div className='enquiry-detail-label'>
															<i className='bi bi-phone'></i><span>Contact number</span>
														</div>
														<div className='enquiry-detail-value'>{notifications[enq].customer_phone}</div>
													</div>
													<div className='enquiry-detail-row' >
														<div className='enquiry-detail-label'>
															<i className='bi bi-house'></i><span>Address</span>
														</div>
														<div className='enquiry-detail-value'>{notifications[enq].customer_address}</div>
													</div>
													<div className='enquiry-detail-row' >
														<div className='enquiry-detail-label'>
															<i className='bi bi-info-circle'></i><span>More details</span>
														</div>
														<div className='enquiry-detail-value'>{notifications[enq].details}</div>
													</div>
													<div className='enquiry-detail-row' >
														<div className='enquiry-detail-label'>
															<i className='bi bi-currency-rupee'></i><span>Service charge</span>
														</div>
														<div className='enquiry-detail-value'>{notifications[enq].service_charge}</div>
													</div>
													<div className='enquiry-detail-row' >
														<div className='enquiry-detail-label'>
															<i className='bi bi-info-circle'></i><span>Remarks</span>
														</div>
														<div className='enquiry-detail-value'>{notifications[enq].required_documents}</div>
													</div>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
										<div className="enquiry-actions">
											{
												user !== undefined ? (
													user.type === 'admin' ? (
														eqId !== undefined && eqId === enq && resolveLoad ? (
															<Button className="enquiry-action-btn" disabled><Spinner animation="border" size="sm" /></Button>
														) : (
															<Button onClick={() => {
																resolvedPeding(enq);
																setEqId(enq);
															}} className="enquiry-action-btn resolve"><i className="bi bi-check-circle"></i> Mark as resolved</Button>
														)
													) : (
														user.permission !== undefined ? (
															user.permission.notification !== undefined && user.permission.notification.E ? (
																eqId !== undefined && eqId === enq && resolveLoad ? (
																	<Button className="enquiry-action-btn" disabled><Spinner animation="border" size="sm" /></Button>
																) : (
																	<Button onClick={() => {
																		resolvedPeding(enq);
																		setEqId(enq);
																	}} className="enquiry-action-btn resolve"><i className="bi bi-check-circle"></i> Mark as resolved</Button>
																)
															) : ''
														) : ''
													)
												) : ''
											}
										</div>
									</div>
								))
							) : ''
						) : 'Not found'
					}
				</div>
				<div className="notifications-tab-content" style={{ display: 'none' }}>
					{
						resolvedNotifi !== undefined ? (
							Object.keys(resolvedNotifi).length > 0 ? (
								Object.keys(resolvedNotifi).map((enq, enq_i) => (
									resolvedNotifi[enq].status ? (
										<div className="enquiry-item grid8by2 align-items-center justify-content-between" key={`enq_${enq_i}`} >
											<Accordion className="p-2">
												<Accordion.Item eventKey="0">
													<Accordion.Header><span className="tp1 f18" >{resolvedNotifi[enq].service_name}, {resolvedNotifi[enq].customer_name}</span></Accordion.Header>
													<Accordion.Body>

														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-calendar-event'></i><span>Created date</span>
															</div>
															<div className='enquiry-detail-value'>{resolvedNotifi[enq].bill_created_date}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-calendar-event'></i><span>Expiry date</span>
															</div>
															<div className='enquiry-detail-value'>{resolvedNotifi[enq].expiry_date}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-person'></i><span>Customer Name</span>
															</div>
															<div className='enquiry-detail-value'>{resolvedNotifi[enq].customer_name}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-phone'></i><span>Contact number</span>
															</div>
															<div className='enquiry-detail-value'>{resolvedNotifi[enq].customer_phone}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-house'></i><span>Address</span>
															</div>
															<div className='enquiry-detail-value'>{resolvedNotifi[enq].customer_address}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-info-circle'></i><span>More details</span>
															</div>
															<div className='enquiry-detail-value'>{resolvedNotifi[enq].details}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-currency-rupee'></i><span>Service charge</span>
															</div>
															<div className='enquiry-detail-value'>{resolvedNotifi[enq].service_charge}</div>
														</div>
														<div className='enquiry-detail-row' >
															<div className='enquiry-detail-label'>
																<i className='bi bi-info-circle'></i><span>Remarks</span>
															</div>
															<div className='enquiry-detail-value'>{resolvedNotifi[enq].required_documents}</div>
														</div>

													</Accordion.Body>
												</Accordion.Item>
											</Accordion>
											<div className="d-flex justify-content-end">
												<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Resolved</span>
											</div>
										</div>
									) : ''
								))
							) : ''
						) : 'Not found'
					}
				</div>
			</div>
		</div>
	);
}